import Vue from 'vue';
import CourseProposalForm from './_components/CourseProposalForm';

new Vue({
    components: {
        CourseProposalForm,
    },
    el: '#vueable',
    data: {
        intro,
        terms,
        classroomRegions,
        recaptchaSitekey,
        dev,
    },
});
